<template>
    <div class="overflow-hidden">
        <template v-if="!testDone">
            <navbar v-if="!testHasStarted" />
            <nav
                v-else
                class="navbar navbar-expand-lg fixed-top navbar-light bg-white shadow-sm py-2 d-flex justify-content-between"
            >
                <img
                    class="navbar-brand ml-0 ml-lg-3 logo-size"
                    src="/images/logo.png"
                    alt="Kovatek"
                />

                <div>
                    <countdown
                        class="test-countdown px-0"
                        :deadline="deadline"
                        @timeElapsed="countdownOver"
                        :showDays="false"
                    ></countdown>
                </div>
            </nav>

            <div class="mt-5 pt-5 kovatek-width-1">
                <home
                    v-if="!testHasStarted"
                    :test="{
                        name: test.Name,
                        language: test.Language,
                        duration: test.Duration,
                    }"
                    :show.sync="testHasStarted"
                />

                <template v-else>
                    <template v-for="(testObj, n) in testQuestions">
                        <test
                            :key="n"
                            @next="current++"
                            v-if="current === n"
                            :test="{
                                ...testObj,
                                no: n + 1,
                                total: testQuestions.length,
                            }"
                            :testID="test.ID"
                        />
                    </template>
                </template>
            </div>
        </template>

        <div v-else class="my-5 py-5 kovatek-width-1">
            <div class="logo">
                <img
                    class="navbar-brand ml-0 ml-lg-3 logo-size"
                    src="/images/logo.png"
                    alt="Kovatek"
                />

                <div class="my-5 w-50 mx-auto">
                    <template v-if="testPassed">
                        <div class="mx-5 mt-5 pt-5">
                            <img style="height:100px;" class="mb-4" src="../assets/kovatek/correct.svg" alt="" />

                            <h5 class="font-weight-bolder ml-1">
                                You have completed the Skills Assessment Exercise as you attained the minimum required
                                test score
                            </h5>
                        </div>
                    </template>
                    <template v-else>
                        <div class="mx-5 mt-5 pt-5">
                            <img style="height:100px;" class="mb-4" src="../assets/kovatek/failed.jpg" alt="" />
                            <h5 class="font-weight-bolder">
                                You have failed the Skills Assessment Exercise as you did not attain the minimum
                                required test score
                            </h5>
                            <br />
                            <h6>
                                You can redo the test in 2 weeks
                            </h6>
                        </div>
                    </template>
                </div>

                <div>
                    <router-link to="/skill-score" class="btn-kovatek px-4 py-2">
                        Go Back
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Countdown from 'vue2-flip-countdown';
import Home from '../components/mcq-test/Home.vue';
import Test from '../components/mcq-test/Test.vue';
import Navbar from '../components/Navbar.vue';

export default {
    components: {
        Countdown,
        Navbar,
        Home,
        Test,
    },
    data() {
        return {
            test: {},
            testHasStarted: false,
            testDone: false,
            current: 0,
            deadline: null,
        };
    },
    computed: {
        testPassed() {
            const { Score, Questions } = this.test;
            return (Score / Questions.length) * 100 >= 80;
        },
        testQuestions() {
            return this.test.Questions || [];
        },
        averageScore() {
            return Math.ceil(this.testQuestions.length / 2);
        },
    },
    watch: {
        current() {
            if (this.current + 1 === this.testQuestions.length) {
                this.closeTest();
            }
        },
    },
    methods: {
        async closeTest() {
            if (this.test.Result !== 0) {
                this.test = await this.getTest(this.test.ID);
            }

            this.testDone = true;
            this.deadline = null;
        },
        async getAllTests() {
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/tests`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const availableTests = res.data
                    .filter(key => key.Locked == false)
                    .sort((a, b) => new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime());

                if (!availableTests.length) return null;
                const test = availableTests[0];
                this.test = test;

                if (test.Result === 0) return this.closeTest();

                // check if test duration has elasped
                const endTime = this.addMinutes(test.CreatedAt, 90);
                if (this.dateHasPassed(endTime)) return this.$router.push('/skill-score');

                this.deadline = this.timeFormat(endTime);
                setTimeout(() => {
                    this.testHasStarted = true;
                }, 5000);

                // this.testHasStarted = true;
            } catch (err) {
                console.log({ err });
                this.catchErrors(err);
            }
        },
        countdownOver(val) {
            console.log(val);
        },
        async getTest(id) {
            this.$store.commit('setLoader', true);
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/tests/${id}`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                this.$store.commit('setLoader', false);
                console.log(res.data);
                return res.data;
            } catch (err) {
                this.catchErrors(err);
                // console.log(err)
            }
        },
        timeFormat: date =>
            new Date(date)
                .toISOString()
                .replace(/T/, ' ')
                .replace(/\..+/, ''),
    },
    async created() {
        this.$store.commit('setLoader', true);
        await Promise.all([this.getProfile(), this.getAllTests()]);
        this.$store.commit('setLoader', false);
    },
};
</script>

<style scoped>
.logo-size {
    height: 35px;
    width: 125px;
}

.test-countdown >>> .flip-clock__piece:first-child,
.test-countdown >>> .flip-clock__slot {
    display: none;
}

.btn-kovatek {
    outline: 0;
    border-radius: 10px;
    -webkit-transition: 0.25s;
    transition: 0.25s;
}
</style>
